import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const InventoryItemKindSchema = z.enum([
  "PRODUCT",
  "RETURN",
  "UNDECLARED",
  "UNKNOWN",
]);

export const InventoryItemGradeSchema = z.string();

export const InventoryItemDispositionSchema = z.enum([
  "restock",
  "liquidate",
  "donate",
  "dispose",
  "return_to_vendor",
]);

export const createInventoryItem = {
  name: "createInventoryItem" as const,
  input: z.object({
    kind: InventoryItemKindSchema,
    locationId: locationIdFormat.schema,
    returnId: z.string().optional(),
    returnItemId: z.string().optional(),
    quantity: z.number().int().positive().optional(),
    grade: InventoryItemGradeSchema.optional(),
    disposition: InventoryItemDispositionSchema.optional(),
  }),
  output: z.object({
    inventoryItem: z.object({
      id: inventoryItemIdFormat.schema,
      kind: InventoryItemKindSchema,
      locationId: locationIdFormat.schema,
      returnId: z.string().nullable(),
      returnItemId: z.string().nullable(),
      quantity: z.number(),
      grade: InventoryItemGradeSchema.nullable(),
      disposition: InventoryItemDispositionSchema.nullable(),
      createdAt: z.date(),
    }),
  }),
};
